module.exports = __webpack_public_path__ + "static/profile-pic-0404ffb81473207d1f55131df26fb3a5.jpg";